<div class="control-line mat-elevation-z8">
    <!-- Market (mat-select with in-panel search) -->
    <div class="filter-actions-line"
        style="box-shadow: none !important; background-color: rgba(255, 255, 255, 0.8) !important; ">

        <mat-form-field appearance="outline" style="width: 260px !important;">
            <mat-label>Site</mat-label>
            <mat-select id="disposalSiteSelect" data-testid="disposalSiteSelect" [value]="selectedSiteId()"
                (selectionChange)="onSiteSelected($event.value)">
                <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                    <input #siteFilterInput matInput placeholder="Search Disposal Site..." [value]="siteQuery()"
                        class="mat-select-search-input" (click)="$event.stopPropagation()"
                        (keydown)="$event.stopPropagation()" (input)="onSiteQuery($event)" />
                    <mat-icon class="mat-select-search-icon">search</mat-icon>
                </div>
                <mat-option [value]="null">--Select Site--</mat-option>
                <mat-option *ngFor="let m of sitesFiltered(); trackBy: trackBySiteId" [value]="m.id">
                    {{ m.siteName }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Tank</mat-label>
            <mat-select id="tankSelect" data-testid="tankSelect" [value]="selectedSiteTankId()"
                (selectionChange)="onSiteTankSelected($event.value)">
                <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                    <input #siteFilterInput matInput placeholder="Search Tank..." [value]="siteTankQuery()"
                        class="mat-select-search-input" (click)="$event.stopPropagation()"
                        (keydown)="$event.stopPropagation()" (input)="onSiteTankQuery($event)" />

                    <mat-icon class="mat-select-search-icon">search</mat-icon>
                </div>
                <mat-option *ngFor="let m of siteTanksFiltered(); trackBy: trackBySiteTankId" [value]="m.id">
                    {{ m.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <!--Date-->
        <!-- <mat-form-field appearance="outline">
            <mat-label>Date</mat-label>
            <input matInput [matDatepicker]="picker" [value]="selectedDate()"
                (dateChange)="selectedDate.set($event.value)" placeholder="Select Date">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field> -->

        <!--Time AM/PM-->
        <!-- <mat-form-field appearance="outline">
            <mat-label>Time</mat-label>
            <mat-select [value]="selectedTime()" (selectionChange)="selectedTime.set($event.value)">
                <mat-option *ngFor="let time of timeSlots()" [value]="time">
                    {{time}}
                </mat-option>
            </mat-select>
        </mat-form-field> -->
        
        @if(isSalisburySite){
            <div class="dt-picker-wrapper">
                <app-datetime-picker-input label="DateTime:" [(ngModel)]="salisburyDateTime"
                    data-testid="dtpicker" panelPosition="left" [use24Hour]="false">
                </app-datetime-picker-input>
            </div>
        }
        @if(controlPermissions.addButton){
            <button (click)="openAddForm()" data-testid="btnAddDailyDosing" mat-raised-button color="primary">
                Add Daily Dosing
            </button>
        }

    </div>
    <div class="gridheight mat-elevation-z8 viewport" *ngIf="showTable" style="margin-top: 13px;">
        <table mat-table *ngIf="dataSource" [dataSource]="dataSource" matSort class="mat-elevation-z8">
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let row">
                    <div>
                        <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit" (click)="openEditForm(row)">
                            <mat-icon matListIcon>edit</mat-icon>
                        </button>
                        @if(controlPermissions.delete){
                            <button mat-icon-button type="button" color="warn" title="Delete" (click)="onDelete(row)" style="color: red;">
                                <mat-icon matListIcon color="warn">delete</mat-icon>
                            </button>
                        }
                        <button mat-icon-button type="button" title="Scratch Pad" (click)="openScratchPadPopup(row)">
                            <mat-icon>note</mat-icon>
                        </button>
                    </div>
                </td>
            </ng-container>
            <!-- Dynamic column defs -->
            <ng-container *ngFor="let col of columns;" [matColumnDef]="col.key">
                <th mat-header-cell *matHeaderCellDef>
                    {{ col.header }}
                </th>
                <td mat-cell *matCellDef="let row">
                    <ng-container [ngSwitch]="col.type">
                        <span *ngSwitchCase="'date'">{{ row[col.key] | date:'MM/dd/yyyy hh:mm a' }}</span>
                        <span *ngSwitchCase="'number'">{{ row[col.key] }}</span>
                        <span *ngSwitchDefault>{{ row[col.key] ?? '' }}</span>
                    </ng-container>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="displayedColumns.length"
                    style="color: red;text-align: center;font-weight: 500;">
                    No Data Found
                </td>
            </tr>
        </table>
    </div>
</div>